<template>
  <div class="orders">
    <!-- 我的包裹 -->
    <div class="card round">
      <header class="card-header">{{ $t('Orders.23mkrm') }}</header>
      <!-- .-1待入库的，0已入库1已发货2待认领，3问题包 -->
      <div class="grid">
        <router-link tag="div" class="cell" :to="{ name: 'EnterPackage' }">
          <div class="icon enter"></div>
          <div class="name">{{ $t('Orders.pg4hvd') }}</div>
        </router-link>
        <div
          class="cell"
          @click="
            $router.push({
              name: 'OrderQuery',
              query: { status: 'outstock', type: 'package' },
            })
          "
        >
          <div class="badge" v-show="stats.pkg_OutStock">
            {{ stats.pkg_OutStock }}
          </div>
          <div class="icon warehousing"></div>
          <div class="name">{{ $t('Orders.bptzff') }}</div>
        </div>
        <div
          class="cell"
          @click="
            $router.push({
              name: 'OrderQuery',
              query: { status: 0, type: 'package' },
            })
          "
        >
          <div class="badge" v-show="stats.pkg_InStock">
            {{ stats.pkg_InStock }}
          </div>
          <div class="icon warehoused"></div>
          <div class="name">{{ $t('Orders.9mbfgh') }}</div>
        </div>
        <div
          class="cell"
          @click="
            $router.push({ name: 'OrderQuery', query: { type: 'packed' } })
          "
        >
          <div class="badge" v-show="stats.pkg_Packed">
            {{ stats.pkg_Packed }}
          </div>
          <div class="icon packed"></div>
          <div class="name">{{ $t('Orders.grsmhw') }}</div>
        </div>
        <div
          class="cell"
          @click="
            $router.push({
              name: 'OrderQuery',
              query: { status: 1, type: 'package' },
            })
          "
        >
          <div class="badge" v-show="stats.pkg_Sended">
            {{ stats.pkg_Sended }}
          </div>
          <div class="icon delivered"></div>
          <div class="name">{{ $t('Orders.gk232r') }}</div>
        </div>
        <div
          class="cell"
          @click="
            $router.push({
              name: 'OrderQuery',
              query: { status: 2, type: 'package' },
            })
          "
        >
          <div class="badge" v-show="stats.pkg_Lost">{{ stats.pkg_Lost }}</div>
          <div class="icon claim"></div>
          <div class="name">{{ $t('Orders.cbi5ag') }}</div>
        </div>
        <div
          class="cell"
          @click="
            $router.push({
              name: 'OrderQuery',
              query: { status: 3, type: 'package' },
            })
          "
        >
          <div class="badge" v-show="stats.pkg_Problem">
            {{ stats.pkg_Problem }}
          </div>
          <div class="icon problem-package"></div>
          <div class="name">{{ $t('Orders.yrfvav') }}</div>
        </div>
      </div>
    </div>
    <!-- 运单中心 -->
    <div class="card round">
      <header class="card-header">{{ $t('Orders.bmz3lu') }}</header>
      <div class="grid">
        <div
          class="cell"
          @click="
            $router.push({
              name: 'OrderQuery',
              query: { status: 0, type: 'order' },
            })
          "
        >
          <div class="badge" v-show="stats.od_WaitAction">
            {{ stats.od_WaitAction }}
          </div>
          <div class="icon processing"></div>
          <div class="name">{{ $t('Orders.thtkyo') }}</div>
        </div>
        <div
          class="cell"
          @click="
            $router.push({
              name: 'OrderQuery',
              query: { status: 1, type: 'order' },
            })
          "
        >
          <div class="badge" v-show="stats.od_WaitForShip">
            {{ stats.od_WaitForShip }}
          </div>
          <div class="icon load"></div>
          <div class="name">{{ $t('Orders.kymm99') }}</div>
        </div>
        <div
          class="cell"
          @click="
            $router.push({
              name: 'OrderQuery',
              query: { status: 2, type: 'order' },
            })
          "
        >
          <div class="badge" v-show="stats.od_Shipping">
            {{ stats.od_Shipping }}
          </div>
          <div class="icon on-the-way"></div>
          <div class="name">{{ $t('Orders.z9yr5v') }}</div>
        </div>
        <div
          class="cell"
          @click="
            $router.push({
              name: 'OrderQuery',
              query: { status: 3, type: 'order' },
            })
          "
        >
          <div class="badge" v-show="stats.od_RecDone">
            {{ stats.od_RecDone }}
          </div>
          <div class="icon order-checked"></div>
          <div class="name">{{ $t('Orders.f7pf4j') }}</div>
        </div>
        <div
          class="cell"
          @click="
            $router.push({
              name: 'OrderQuery',
              query: { status: -1, type: 'order' },
            })
          "
        >
          <div class="badge" v-show="stats.od_Cancel">
            {{ stats.od_Cancel }}
          </div>
          <div class="icon canceled"></div>
          <div class="name">{{ $t('Orders.eif2md') }}</div>
        </div>
        <div
          class="cell"
          @click="
            $router.push({
              name: 'OrderQuery',
              query: { status: 6, type: 'order' },
            })
          "
        >
          <div class="badge" v-show="stats.od_ErropExp">
            {{ stats.od_ErropExp }}
          </div>
          <div class="icon problem-order"></div>
          <div class="name">{{ $t('Orders.30go9b') }}</div>
        </div>
      </div>
    </div>
    <!-- 打包单 -->
    <div class="card round hidden">
      <header class="card-header">{{ $t('Orders.wwampb') }}</header>
      <div class="grid">
        <div
          class="cell"
          @click="$router.push({ name: 'OrderQuery', query: { status: 1 } })"
        >
          <div class="icon package"></div>
          <div class="name">{{ $t('Orders.vthnqw') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getStatsData } from '@/api/deliver.js';
export default {
  data() {
    return {
      stats: {},
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$toast.loading();
      getStatsData({})
        .then(res => {
          this.stats = res;
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '~@/styles/_var';
.orders {
  padding: rem(20px);
}
.card {
  margin-bottom: rem(20px);
  background-color: #fff;
}
.card-header {
  padding: rem(20px);
  border-bottom: 1px solid #f6f6f6;
}
.grid {
  display: grid;
  grid-template-columns: repeat(4, 25%);
}

.cell {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  height: rem(158px);
  border-right: 1px solid #f6f6f6;
  border-bottom: 1px solid #f6f6f6;
  position: relative;
  .name {
    font-size: 12px;
  }
}

.icon {
  width: rem(60px);
  height: rem(60px);
  background-size: contain;
  background-repeat: no-repeat;
  &.enter {
    background-image: url(~@/assets/images/enter.png);
  }
  &.warehousing {
    background-image: url(~@/assets/images/warehousing.png);
  }
  &.warehoused {
    background-image: url(~@/assets/images/warehoused.png);
  }
  &.packed {
    background-image: url(~@/assets/images/packed.png);
  }
  &.delivered {
    background-image: url(~@/assets/images/delivered.png);
  }
  &.claim {
    background-image: url(~@/assets/images/claim.png);
  }
  &.problem-package {
    background-image: url(~@/assets/images/problem-package.png);
  }
  &.on-the-way {
    background-image: url(~@/assets/images/on-the-way.png);
  }
  &.load {
    background-image: url(~@/assets/images/load.png);
  }
  &.order-checked {
    background-image: url(~@/assets/images/orderchecked.png);
  }
  &.canceled {
    background-image: url(~@/assets/images/canceled.png);
  }
  &.problem-order {
    background-image: url(~@/assets/images/problem-order.png);
  }
  &.processing {
    background-image: url(~@/assets/images/processing.png);
  }
  &.package {
    background-image: url(~@/assets/images/package.png);
  }
}
.badge {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #ee0a24;
  color: #fff;
  font-size: 12px;
  border-radius: 5px;
  padding: 0 rem(6px);
}
</style>
